export default {
    NoteRows: 'البند|البنود',
};
